/* eslint no-shadow: 0 */

import actions from './actions';
import mutations from './mutations';

const state = {
  lastClosedAt: parseInt(localStorage.getItem('modalLastClosedAt'), 10) || null,
};

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default module;
